import {createSlice} from '@reduxjs/toolkit';
import {validateFields, validateField} from '../../../../utilities/validation/validator';
import {regexPatterns} from '../../../../utilities/validation/validationVariables';
import lodash from 'lodash';

const initialState = {
  form: {
    userName: '',
    id: '',
    CardNumber: '',
    CardDueYear: '',
    CardDueMonth: '',
    CVV: '',
    paymentCount: '',
    valid: '',
    errors: {},

    rules: {
      CardNumber: {
        required: {value: true, error: 'שדה מס אשראי חובה'},
        pattern: {
          value: regexPatterns.numbersRegex,
          error: 'ערך לא תקין',
        },
      },
      CardDueYear: {
        required: {value: true, error: 'לא נבחרה שנה'},
        minLength: {
          value: 2,
          error: 'חובה להזין ערך בין 2 תווים',
        },
        maxLength: {
          value: 2,
          error: 'חובה להזין ערך בין 2 תווים',
        },
        pattern: {
          value: regexPatterns.yearDate,
          error: 'ערך לא תקין',
        },
      },
      CardDueMonth: {
        required: {value: true, error: 'לא נבחר חודש'},
        minLength: {
          value: 2,
          error: 'חובה להזין ערך בין 2 תווים',
        },
        maxLength: {
          value: 2,
          error: 'חובה להזין ערך בין 2 תווים',
        },
        pattern: {
          value: regexPatterns.monthDate,
          error: 'ערך לא תקין',
        },
      },
      CVV: {
        required: {value: true, error: 'לא נבחר '},
        minLength: {
          value: 3,
          error: 'חובה להזין ערך בין 3 תווים',
        },
        maxLength: {
          value: 3,
          error: 'חובה להזין ערך בין 3 תווים',
        },
        pattern: {
          value: regexPatterns.numbersRegex,
          error: 'ערך לא תקין',
        },
      },
    },
  },
  CCData: {},
  isTermsAccepted: false,
  isTermsMsg: false,
  CCError: false,
  togglePopover: false,
};

const PaymentSlice = createSlice({
  name: 'payment',
  initialState: initialState,
  reducers: {
    resetStore: (state) => initialState,
    validateHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const validate = validateFields(lodash.cloneDeep(payload));
        return {payload: validate};
      },
    },
    reportAnalytics: (state, action) => {},
    changeHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        const validate = validateField(form, name, value);
        return {payload: validate};
      },
    },
    onCheck: {
      reducer(state, action) {
        if (!state.isTermsAccepted) state.isTermsAccepted = true;
      },
    },
    onUncheck: {
      reducer(state, action) {
        if (state.isTermsAccepted) state.isTermsAccepted = false;
      },
    },
    termsMsg: {
      reducer(state, action) {
        state.isTermsMsg = action.payload;
      },
    },
    isCreditCardError: {
      reducer(state, action) {
        state.CCError = action.payload;
      },
    },
    creditCardData: {
      reducer(state, action) {
        state.CCData = action.payload;
      },
    },
    setId: {
      reducer(state, action) {
        if (state.form.id === '') {
          state.form.id = action.payload;
        }
      },
    },
    openPopover: {
      reducer(state, action) {
        if (state.togglePopover === false) {
          state.togglePopover = true;
        } else {
          state.togglePopover = false;
        }
      },
    },
    closePopover: {
      reducer(state, action) {
        if (state.togglePopover === true) {
          state.togglePopover = false;
        }
      },
    },
    initValidation: {
      reducer(state, action) {
        state.form.valid = '';
      },
    },
  },
});

export const {
  changeHandler,
  validateHandler,
  onCheck,
  onUncheck,
  termsMsg,
  isCreditCardError,
  creditCardData,
  setId,
  resetStore,
  openPopover,
  closePopover,
  initValidation,
  reportAnalytics,
} = PaymentSlice.actions;

export default PaymentSlice.reducer;
